import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Users, ChevronRight } from "lucide-react";

const dataOra = (iso) => {
  const [d, t] = (iso || "").split("T");
  return d ? `${d.split("-").reverse().join("/")}${t ? ` · ${t.slice(0, 5)}` : ""}` : "";
};

// Home: riquadro RIUNIONI (task aperti dai verbali assegnati a me + prossima riunione).
export function AzioniRiunioniCard() {
  const [d, setD] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/riunioni-home").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <button data-testid="home-azioni-riunioni" onClick={() => nav("/riunioni")}
      className="group w-full mb-5 text-left rounded-3xl bg-[#2B2B2B] text-white px-5 py-4 flex items-center gap-4 flex-wrap hover:-translate-y-0.5 hover:shadow-[0_12px_30px_rgba(43,43,43,0.25)] transition-[transform,box-shadow]">
      <span className="w-11 h-11 rounded-2xl bg-[#FC82ED] text-[#2B2B2B] flex items-center justify-center"><Users size={20} /></span>
      <div className="min-w-0"><div className="text-[11px] font-bold uppercase tracking-[0.14em] text-white/60">Riunioni</div>
        <div className="font-display font-extrabold text-xl"><span data-testid="home-azioni-n" className="text-[#FC82ED]">{d.mie_aperte}</span> {d.mie_aperte === 1 ? "task aperto dalle riunioni" : "task aperti dalle riunioni"}</div></div>
      <div className="ml-auto text-sm text-white/80 min-w-0" data-testid="home-prossima-riunione">
        {d.prossima ? <span>Prossima: <b className="text-white">{d.prossima.titolo}</b> · {dataOra(d.prossima.data)}</span> : "Nessuna riunione in programma"}
      </div>
      <ChevronRight size={18} className="text-[#FC82ED] group-hover:translate-x-1 transition-transform" />
    </button>
  );
}
